// extracted by mini-css-extract-plugin
export var activeFilterButton = "_jb-c";
export var backButton = "_jb-4";
export var backIcon = "_jb-5";
export var chevronShortcut = "_jb-6";
export var container = "_jb-1";
export var editor = "_jb-8";
export var editorWrapper = "_jb-7";
export var prefix = "_jb-2";
export var searchIcon = "_jb-3";
export var suffix = "_jb-9";
export var suffixContent = "_jb-a";
export var suffixText = "_jb-b";
export var wrapper = "_jb-0";